import { render, staticRenderFns } from "./ProductTemplate.vue?vue&type=template&id=695c34c0&scoped=true&"
import script from "./ProductTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProductTemplate.vue?vue&type=style&index=0&id=695c34c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695c34c0",
  null
  
)

export default component.exports